import { Outlet } from 'react-router-dom';
import { Masthead } from '@/components/Masthead';

/**
 * Port of the old `_boundary._client.tsx` layout: renders the Masthead above
 * all `/client/*` routes. Auth is enforced per-page via <ProtectedRoute>.
 */
export function ClientLayout() {
    return (
        <>
            <Masthead />
            <Outlet />
        </>
    );
}
